<template lang="pug">
  Slide(:enable-scroll-indication="true")
    .content-container
      h1 Mobile Device Security

      p.instructions Modern smartphones harness an amazing combination of connectivity and convenience. That combination also makes them a top target for cybercriminals.
      p.instructions Select each icon to learn about protecting the computer in your pocket. 

      ModalStack
        .modal-container
          Modal(
            title="Malicious Apps"
            :image="require('@/assets/images/1100_1_MaliciousApps.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckPink.png')"
            alt-completed="completed"
            :video="require('@/assets/videos/1100_1_HC_2023_Malicious_Apps.mp4')"
            :vtt="require('@/assets/videos/1100_1_HC_2023_Malicious_Apps.vtt')"
            :video-background-theme="dark"
            :completion-by-inner-component="true"
            size="normal"
          )
          Modal(
            title="Permissions"
            :image="require('@/assets/images/1100_2_Permissions.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckBlue.png')"
            alt-completed="completed"
            :video="require('@/assets/videos/1100_2_HC_2023_Permissions.mp4')"
            :vtt="require('@/assets/videos/1100_2_HC_2023_Permissions.vtt')"
            :video-background-theme="dark"
            :completion-by-inner-component="true"
            size="normal"
          )
          Modal(
            title="Physical Security"
            :image="require('@/assets/images/1100_3_PhysicalSecurity.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckGreen.png')"
            alt-completed="completed"
            :video="require('@/assets/videos/1100_3_HC_2023_Phyical_Security.mp4')"
            :vtt="require('@/assets/videos/1100_3_HC_2023_Phyical_Security.vtt')"
            :video-background-theme="dark"
            :completion-by-inner-component="true"
            size="normal"
          )
    
</template>

<script>
export default {
  methods: {
    attachModalCSS() {
        document.querySelector('body').classList.add('video-modals')
    },
    detachModalCSS() {
        document.querySelector('body').classList.remove('video-modals')
    }
  },
  mounted() {
    this.attachModalCSS()
  },
  destroyed() {
    this.detachModalCSS()
  }
}
</script>

<style lang='scss'>
@import "@/assets/css/_modals";
</style>

<style scoped lang="scss">
@import "@/assets/css/styles";

/* page styling */

.slide-wrapper {
  padding: 40px !important;
  background-image: url('../assets/backgrounds/BG_Desktop_Purple.png')
}
.content-container {
  min-height: 100%;
  background-color: $light-purple;
  padding: 20px;
  box-shadow: 5px 5px 3px #00000033;
  h1 {
    @include fs-section-header;
    text-align: center;
  }
  .instructions {
    @include fs-instructions();
  }

}
.ModalStack {
  .modal-container {
    height: 100%;
    max-width: 885px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
    justify-content: center;
    margin: 0 auto;
    .modal {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: white;
      min-width: 270px;
      height: 240px;
      padding: 5px;
      border-radius: 10px;
      box-shadow: 5px 5px 3px #00000033;
      ::v-deep .modal-controller {
        img {
          width: auto;
          height: 100%;
          max-height: 100px;
        }
        .h4 {
          color: black;
          margin-bottom: 20px;
          font-size: 1.5rem;
        }
      }
    }
  }
}

</style>
